import React from 'react';
import UltraRealisticGlobe from './UltraRealisticGlobe';

function App() {
  return (
    <div className="App">
      <UltraRealisticGlobe />
    </div>
  );
}

export default App;